const { View } = window.App;
const SELECTOR = '.js-header';

class Header{
    constructor( el ){
        this.el = el;
        this.$el = $( el );

        this.$parent_menus = this.$el.find( SELECTOR + "__parent-menu" );
        this.$sub_menus = this.$el.find( SELECTOR + "__sub-menu" );
        this.$sub_menu_spacers = this.$el.find( SELECTOR + "__sub-menu-spacer" );

        this.$parent_menus.on( {
            mouseenter: $.proxy( this.parentMenuMouseIn, this ),
            mouseleave: $.proxy( this.parentMenuMouseOut, this ),
        } );

        this.$sub_menus.on( {
            mouseenter: $.proxy( this.subMenuMouseIn, this ),
            mouseleave: $.proxy( this.subMenuMouseOut, this ),
        } );

        window.App.$window.on( {
            resize: $.proxy( this.setSpacerWidth, this ),
            scroll: $.proxy( this.onScroll, this ),
        } )
        ;
        this.setSpacerWidth();
    }

    parentMenuMouseIn( e ){
        let $target = $( e.currentTarget );
        $target.addClass( '__visible' );
        this.__getMenuOf( e.currentTarget ).addClass( '__visible' );
    }

    parentMenuMouseOut( e ){
        let $target = $( e.currentTarget );
        $target.removeClass( '__visible' );
        this.__getMenuOf( e.currentTarget ).removeClass( '__visible' );
    }

    subMenuMouseIn( e ){
        let target = e.currentTarget;
        this.__getParentOf( target ).addClass( '__visible' );
        $( target ).addClass( '__visible' );
    }

    subMenuMouseOut( e ){
        let target = e.currentTarget;
        this.__getParentOf( target ).removeClass( '__visible' );
        $( target ).removeClass( '__visible' );
    }

    setSpacerWidth(){
        this.$parent_menus.each( ( index, el ) => {
            let $el = $( el ),
                $link = $el.find( 'a' ),
                $menu = this.__getMenuOf( el ),
                $spacer = $menu.find( this.$sub_menu_spacers );

            $spacer.width( $el.offset().left + parseInt( $link.css( 'padding-left' ), 10 ) );
        } );
    }

    onScroll(){
        let scroll_top = window.App.$window.scrollTop();
        this.$el.toggleClass( '__scrolled', scroll_top > 50 );
    }

    __getParentOf( el ){
        return this.$parent_menus.filter( `[data-menu-id="#${ el.id }"]` );
    }

    __getMenuOf( el ){
        let menu_id = $( el ).data( 'menu-id' );
        return this.$sub_menus.filter( menu_id )
    }
}

View.addHook( 'init', _ => {
    $( SELECTOR ).each( function(){
        new Header( this );
    } );
}, 100 );



// WEBPACK FOOTER //
// ./resources/js/modules/header.js